import { Spinner } from '@vwfs-bronson/bronson-react';
import React from 'react';

export const DefaultLoading: React.FunctionComponent = () => <Spinner center fullPage />;
